import { useState, useEffect } from 'react'

export const MOBILE_MAX_WIDTH = 767
export const TABLET_MAX_WIDTH = 1023

interface DeviceDimension {
    isMobile: boolean
    isTablet: boolean
}

export function useDeviceType(): DeviceDimension {
    const [device, setDevice] = useState<DeviceDimension>({
        isMobile: false,
        isTablet: false
    })

    useEffect(() => {
        const mobileQuery = window.matchMedia(
            `(max-width: ${MOBILE_MAX_WIDTH}px)`
        )
        const tabletQuery = window.matchMedia(
            `(min-width: ${
                MOBILE_MAX_WIDTH + 1
            }px) and (max-width: ${TABLET_MAX_WIDTH}px)`
        )

        const updateDeviceType = () => {
            setDevice({
                isMobile: mobileQuery.matches,
                isTablet: tabletQuery.matches
            })
        }

        updateDeviceType()

        mobileQuery.addEventListener('change', updateDeviceType)
        tabletQuery.addEventListener('change', updateDeviceType)

        return () => {
            mobileQuery.removeEventListener('change', updateDeviceType)
            tabletQuery.removeEventListener('change', updateDeviceType)
        }
    }, [])

    return device
}
